module.exports = __webpack_public_path__ + "static/img/2.1b1f828.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-hogar/2.png
// module id = O3Xk
// module chunks = 0